import { ShowModal as UseCaseReduxSetShowModal } from '../../../../domain/usecases/showModal/redux';

import { ReduxSetShowModal } from '../../../../data/store/reducer/showModal/usecases/ReduxSetShowModal';

/**
 * send request via REDUX.
 */
export const makeReduxSetShowModal = (): UseCaseReduxSetShowModal =>
  new ReduxSetShowModal();
